import Cookies from "js-cookie";
export const getTaticIdObj = () => {
	const internalTacticId = Cookies.get("rh_omni_itc");
	const externalTacticId = Cookies.get("rh_omni_tc");
	const personalizationTacticId = Cookies.get("rh_omni_pc");
	return {
		...(internalTacticId && { internalTacticId }),
		...(externalTacticId && { externalTacticId }),
		...(personalizationTacticId && { personalizationTacticId }),
	};
};
